export const apiName: string = 'pessoas';
export const pessoasRoute: string = 'pessoas';
export const pessoasStorage: string = 'pessoas';
export const pessoasModuleName: any = {plural: 'Pessoas', single: 'Pessoa'};

export const pessoaImageApiName: string = 'imagens-pessoas';

    export const pessoasQuery: any = {
    "where":{
        "ativo":true,
        "nome":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"nome"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoas/shared/data.service.ts
 **/